export default __webpack_public_path__ + "static/media/maestro.9e912a69.svg";